import { getPropertyResolver } from 'reference-resolvers-lite/utils/getPropertyResolver';
import { MULTI_CURRENCY_CURRENCY_CODE } from 'reference-resolvers-lite/constants/ReferenceTypes';
import { getReferenceTypeFromProperty } from 'reference-resolvers-lite/utils/getReferenceTypeFromProperty';
const isCurrencyCode = (property, objectTypeId) => {
  return getReferenceTypeFromProperty(property, objectTypeId) === MULTI_CURRENCY_CURRENCY_CODE;
};
const createReferenceTypeResolver = ({
  property,
  objectTypeId
}) => getPropertyResolver({
  property,
  objectTypeId,
  // "Deleted" currencies are really just archived and can still be used on
  // objects so we want to show them in dropdowns so users can take action on
  // objects that still use them.
  searchIncludeDeleted: isCurrencyCode(property, objectTypeId)
});
export default createReferenceTypeResolver;